import {IChannelPrice} from '../../../app/administrator/channel-price/interfaces/IChannelPrice';
import BaseApi from '../../base.api';

const CHANNEL_PRICE_ROUTE = '/api/admin/channel/price';

export class ChannelPriceApi extends BaseApi {
  public async getChannelPrices(companyID?: number | null): Promise<{data: {channels: IChannelPrice[]}}> {
    return await this.get(CHANNEL_PRICE_ROUTE, '', {companyID: companyID ?? null});
  }

  public async updateChannelPrices(data: IChannelPrice[], companyID?: number | null): Promise<{data: {channels: IChannelPrice[]}}> {
    return await this.put(
      CHANNEL_PRICE_ROUTE,
      {
        channels: data,
      },
      '',
      false,
      {
        companyID: companyID ?? null,
      }
    );
  }
}
